import { defineMessages } from 'react-intl';

export const texts = defineMessages({
  buttonCancel: {
    id: 'ActionModal.buttonCancel',
    description: 'Button cancel',
    defaultMessage: 'Avbryt',
  },
});
